import { createGlobalStyle } from 'styled-components';

export const GlobalWhiteStyle = createGlobalStyle`
  * {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  body, html {
    height: 100%;
  }

  [hidden] {
    display: none !important;
  }

  .bp-3386 .breadcrumbs, .bp-3442 .breadcrumbs {
    display: none !important;
  }

  ::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: white; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 310px; /* закругления плашки */
    background: black;
    border: 1px solid rgba(254, 254, 254, 0.13);
  }
`;
import { createGlobalStyle } from 'styled-components';

export const GlobalWhiteStyle = createGlobalStyle`
  * {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  body, html {
    height: 100%;
  }

  [hidden] {
    display: none !important;
  }

  .bp-3386 .breadcrumbs, .bp-3442 .breadcrumbs {
    display: none !important;
  }

  ::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: white; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 310px; /* закругления плашки */
    background: black;
    border: 1px solid rgba(254, 254, 254, 0.13);
  }
`;
